import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    ssoAction: String,
    domains: Array,
  };

  static targets = ["submit", "email", "ssoHidden"];

  connect() {
    this.domains = new Set(this.domainsValue.filter(Boolean).map(d => d.trim().toLowerCase()));

    this.wasSSO = null;
    this.initialSubmitLabel = this.submitTarget.value;
    this.ssoClickHandler = () => {
      window.location.href = this.ssoActionValue + "?email=" + encodeURIComponent(this.emailTarget.value);
    };
    this.formSubmitHandler = (event) => {
      if (this.wasSSO) {
        event.preventDefault();
        this.ssoClickHandler();
      }
    };
    this.element.addEventListener('submit', this.formSubmitHandler);
    this.setMode(this.looksLikeSSO(this.emailTarget.value));
  }

  disconnect() {
    this.element.removeEventListener('submit', this.formSubmitHandler);
    this.submitTarget.removeEventListener('click', this.ssoClickHandler);
    this.submitTarget.type = 'submit';
    this.submitTarget.value = this.initialSubmitLabel;
  }

  /**
   * Update form when user email is changed.
   * @param {InputEvent} ev
   */
  input({ target: { value } }) {
    const isSSO = this.looksLikeSSO(value);
    this.setMode(isSSO);
  }

  /**
   * Check if a given email looks like a SSO domain.
   * @param {string} email 
   * @returns {boolean}
   */
  looksLikeSSO(email) {
    const emailParts = email.trim().split('@');
    if (emailParts.length !== 2) {
      return false;
    }

    const [prefix, domain] = emailParts;
    if (prefix.includes('+')) {
      return false;
    }

    return this.domains.has(domain.toLowerCase());
  }

  /**
   * Set if the form should function as password or SSO.
   * @param {boolean} sso 
   */
  setMode(sso) {
    if (sso === this.wasSSO) {
      return;
    }

    if (sso) {
      this.submitTarget.type = 'button';
      this.submitTarget.value = 'Log in with SSO';
      this.submitTarget.addEventListener('click', this.ssoClickHandler);
    } else {
      this.submitTarget.type = 'submit';
      this.submitTarget.value = this.initialSubmitLabel;
      this.submitTarget.removeEventListener('click', this.ssoClickHandler);
    }

    this.ssoHiddenTargets.forEach((target) => {
      target.classList.toggle('d-none', sso);
      if (target.tagName === 'INPUT') {
        target.disabled = sso;
      }
    });

    this.wasSSO = sso;
  }
}
